import { render, staticRenderFns } from "./productMove.vue?vue&type=template&id=2b1a84cb&scoped=true"
import script from "./productMove.vue?vue&type=script&lang=js"
export * from "./productMove.vue?vue&type=script&lang=js"
import style0 from "./productMove.vue?vue&type=style&index=0&id=2b1a84cb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1a84cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b1a84cb')) {
      api.createRecord('2b1a84cb', component.options)
    } else {
      api.reload('2b1a84cb', component.options)
    }
    module.hot.accept("./productMove.vue?vue&type=template&id=2b1a84cb&scoped=true", function () {
      api.rerender('2b1a84cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plan/leftMoudle/dialog/productMove.vue"
export default component.exports